import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ApiMessageService } from '../services/notification/api-message.service';

@Injectable()
export class HttpStatusInterceptor implements HttpInterceptor {
  constructor(private readonly msgService: ApiMessageService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const successAction = req.headers.get('X-Show-Success'); // 'create' | 'update' | 'delete'
    const entityName = req.headers.get('X-Entity-Name') || 'informação';
    const entityArticle = req.headers.get('X-Entity-Article') || 'do';

    // Remove os headers internos antes de enviar ao servidor (RFC 7230 exige apenas US-ASCII)
    const cleanedReq = req.clone({
      headers: req.headers
        .delete('X-Show-Success')
        .delete('X-Entity-Name')
        .delete('X-Entity-Article')
        .delete('X-Handle-Error-Locally'),
    });

    return next.handle(cleanedReq).pipe(
      tap({
        next: (event) => {
          if (
            event instanceof HttpResponse &&
            [200, 201, 204].includes(event.status) &&
            successAction
          ) {
            switch (successAction) {
              case 'create':
                this.msgService.showSuccess(
                  `Informação ${entityArticle} ${entityName} adicionada com sucesso!`,
                );
                break;
              case 'update':
                this.msgService.showSuccess(
                  `Informação ${entityArticle} ${entityName} atualizada com sucesso!`,
                );
                break;
              case 'delete':
                this.msgService.showSuccess(
                  `Informação ${entityArticle} ${entityName} excluída com sucesso!`,
                );
                break;
            }
          }
        },
        error: (error: HttpErrorResponse) => {
          // Se o header X-Handle-Error-Locally existir, o erro será tratado localmente pelo componente
          const handleErrorLocally = req.headers.get('X-Handle-Error-Locally');
          if (handleErrorLocally === 'true') {
            return; // Não exibe mensagem de erro, deixa o componente tratar
          }

          const action = req.headers.get('X-Show-Success'); // 'create' | 'update' | 'delete'
          const entity = req.headers.get('X-Entity-Name') || 'informação';
          const entityArticle = req.headers.get('X-Entity-Article') || 'do';
          switch (error.status) {
            case 409: {
              let message409 = '';
              switch (action) {
                case 'create':
                  message409 = `Não foi possível incluir o(a) ${entity}, pois já existe um registro com informações semelhantes. Verifique os dados!`;
                  break;
                case 'update':
                  message409 = `Não foi possível atualizar o(a) ${entity}. Os dados foram modificados por outra pessoa. Por favor, atualize a página.`;
                  break;
                case 'delete':
                  message409 = `Não foi possível excluir o(a) ${entity} porque está vinculado a outros registros.`;
                  break;
                default:
                  message409 =
                    'Ocorreu um conflito de dados ao processar a requisição.';
              }
              this.msgService.showError(message409);
              break;
            }
            case 400:
            case 422: {
              let message400 =
                'Os dados enviados são inválidos. Por favor, verifique os campos do formulário.';
              if (action === 'update') {
                message400 = `A atualização ${entityArticle} ${entity} falhou devido a dados inválidos.`;
              } else if (action === 'delete') {
                message400 = `A solicitação para excluir ${entityArticle} ${entity} é inválida.`;
              }
              this.msgService.showError(message400);
              break;
            }

            case 404:
              this.msgService.showError(
                'O recurso solicitado não foi encontrado.',
              );
              break;
            case 401:
              this.msgService.showError('Não autorizado.');
              break;
            case 403:
              this.msgService.showError('Acesso negado.');
              break;
            case 500:
              this.msgService.showError('Erro interno do servidor.');
              break;
            case 0:
              this.msgService.showError(
                'Dados meteorológicos temporariamente indisponíveis. Por favor, tente novamente mais tarde.',
              );
              break;
            default:
              this.msgService.showError(
                `Erro ${error.status}: ${error.statusText}`,
              );
          }
        },
      }),
    );
  }
}
